/**
 * Gera HMAC-SHA256 do input com a chave secreta
 * @param message - texto a ser assinado
 * @param secret - chave secreta
 * @returns hash hex de 64 caracteres
 */
async function hmacSHA256(message: string, secret: string): Promise<string> {
  const enc = new TextEncoder();
  const key = await crypto.subtle.importKey(
    "raw",
    enc.encode(secret),
    { name: "HMAC", hash: "SHA-256" },
    false,
    ["sign"]
  );
  const signature = await crypto.subtle.sign("HMAC", key, enc.encode(message));
  return Array.from(new Uint8Array(signature))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}

/**
 * Gera um token seguro: timestamp + HMAC-SHA256(timestamp + chave)
 */
export async function generateSecureToken(secretKey: string): Promise<string> {
  const timestamp = Math.floor(Date.now() / 1000).toString();
  const hash = await hmacSHA256(timestamp + secretKey, secretKey);
  return timestamp + hash;
}

/**
 * Gera URL segura para seu CDN/worker, anexando o token na query string
 */
export async function generateSecureUrl(path: string, secretKey: string): Promise<string> {
  const token = await generateSecureToken(secretKey);
  return `https://secure.playflix.fun${path}?${token}`;
}
